import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantShopPayRentalConfirmPage } from './merchant-shop-pay-rental-confirm';

@NgModule({
  declarations: [
    MerchantShopPayRentalConfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantShopPayRentalConfirmPage),
    TranslateModule.forChild()
  ],
})
export class MerchantShopPayRentalConfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-shop-pay-rental-confirm/merchant-shop-pay-rental-confirm.module.ts